import { IMultiRecordsComponent } from "../Frames/FrameInterfaces";
import { XGButton, XGButtonParams } from "./XGButton";

export abstract class MultiObjectButton extends XGButton {
    private _isMultiSelectState: boolean = false;

    //#region Constructors
    constructor(params: XGButtonParams) {
        super(params);
        const { action } = params;

        action.ownerChanged.add((_sender, prm) => {
            if (prm instanceof IMultiRecordsComponent) {
                prm.selectionModeChanged.add((_sender, prm2) => {
                    if (prm2) {
                        this.visible = true;
                        this.enabled = true;
                        this._isMultiSelectState = true;
                    } else
                        this._isMultiSelectState = false;
                });
            }
        });
    }
    //#endregion Constructors

    protected override _updateActiveState(): void {
        if (!this._isMultiSelectState)
            super._updateActiveState();
    }

    protected override _updateVisibleState(): void {
        if (!this._isMultiSelectState)
            super._updateVisibleState();
    }
}
